export default __webpack_public_path__ + "static/media/usdc.d964aa68.svg";